var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5801",
    "data-name": "Group 5801",
    transform: "translate(-562 -512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5800",
    "data-name": "Group 5800",
    transform: "translate(-544 35)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_863",
    "data-name": "Ellipse 863",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1106 477)",
    fill: "#eae2fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29170",
    "data-name": "Path 29170",
    d: "M3,8.25V18a2.25,2.25,0,0,0,2.25,2.25h13.5A2.25,2.25,0,0,0,21,18V8.25m-18,0V6A2.25,2.25,0,0,1,5.25,3.75h13.5A2.25,2.25,0,0,1,21,6V8.25m-18,0H21M5.25,6h.008v.008H5.25ZM7.5,6h.008v.008H7.5ZM9.75,6h.008v.008H9.75Z",
    transform: "translate(575.5 524.75)",
    fill: "none",
    stroke: "#8467cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageIcon);
export default __webpack_public_path__ + "static/media/landingPageIcon.a43aa77bef74b798dc3bdb1124d12b65.svg";
export { ForwardRef as ReactComponent };